import LoadingCircle from '../../shared/LoadingCircle';

const SuspenseFallbackPrivate = () => (
  <div className="flex flex-1 justify-center align-center h-[calc(100vh-120px)] sm:h-[calc(100vh-theme(height.header))]">
    <LoadingCircle />
  </div>
);

export default SuspenseFallbackPrivate;
